// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Ey--","productName":"Table_productName__3GOOD"};